import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import 'moment-timezone';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
